module.exports = "/_next/static/images/OrchestrateAndOptimize@2x-b20f799c12476a092a08fdd0e1e68d4c.webp";